/**
 * TripAdvisor wording for the search rating-filter buckets. The four searchable buckets and
 * their thresholds are fixed (memsearch maps the bucket names to raw score ranges), so
 * TripAdvisor mode only swaps the copy: each bucket shows the TA-taxonomy band closest to its
 * threshold — 'pleasant' (raw 60 → 3.2 bubbles) reads "Average". The sub-3-bubble TA bands
 * (poor/terrible) are deliberately not offered, keeping the searchable floor at 'pleasant'.
 */
export const TA_RATING_FILTER_TRANSLATION_KEYS: Record<string, string> = {
  excellent: 'vacation.common.rating.excellent',
  verygood: 'vacation.common.rating.verygood',
  good: 'vacation.common.rating.good',
  pleasant: 'vacation.common.rating.average',
};
